var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "epf-filter__buttons", class: _vm.additionalClass },
    [
      _c("h3", { staticClass: "epf-filter__buttons__title" }, [
        _vm._v(_vm._s(_vm.filterConfig.title)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "epf-filter__buttons__wrap" },
        _vm._l(_vm.availableOptions, function (option) {
          return _c("global-button", {
            key: option.value || option,
            attrs: {
              theme: _vm.isSelectedOption(option) ? "primary" : "secondary",
            },
            domProps: {
              innerHTML: _vm._s(option.title || option.value || option),
            },
            on: {
              click: function ($event) {
                return _vm.selectOption(option)
              },
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "epf-filter__buttons__footnote" }, [
        _c(
          "small",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.selectedOption.footnote,
                expression: "selectedOption.footnote",
              },
            ],
          },
          [_vm._v("(" + _vm._s(_vm.selectedOption.footnote) + ")")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }